export default __webpack_public_path__ + "static/media/noRecords.63c54b52.svg";